import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './ResearchDocViewer.css';

/** Research MD — GFM 렌더 (테이블·코드블록·인용 등) */
export default function ResearchDocViewer({ content }: { content: string }) {
  return (
    <div className="research-md">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
    </div>
  );
}
